// Centralized date/time formatting for Italy (Europe/Rome timezone).
// Use these helpers everywhere instead of .toLocaleString / string slicing
// so the displayed time is always Italian local time, regardless of where
// the user's device is.

const ROME = { timeZone: "Europe/Rome" };

export function formatDateIT(input, opts = {}) {
  if (!input) return "";
  try {
    const d = input instanceof Date ? input : new Date(input);
    if (Number.isNaN(d.getTime())) return "";
    return d.toLocaleDateString("it-IT", { ...opts, ...ROME });
  } catch {
    return "";
  }
}

export function formatDateTimeIT(input, opts = {}) {
  if (!input) return "";
  try {
    const d = input instanceof Date ? input : new Date(input);
    if (Number.isNaN(d.getTime())) return "";
    return d.toLocaleString("it-IT", {
      day: "2-digit", month: "2-digit", year: "numeric",
      hour: "2-digit", minute: "2-digit",
      ...opts, ...ROME,
    });
  } catch {
    return "";
  }
}

export function formatTimeIT(input, opts = {}) {
  if (!input) return "";
  try {
    const d = input instanceof Date ? input : new Date(input);
    if (Number.isNaN(d.getTime())) return "";
    return d.toLocaleTimeString("it-IT", {
      hour: "2-digit", minute: "2-digit",
      ...opts, ...ROME,
    });
  } catch {
    return "";
  }
}

export function formatTimelineIT(input) {
  if (!input) return "";
  try {
    const d = input instanceof Date ? input : new Date(input);
    if (Number.isNaN(d.getTime())) return "";
    return d.toLocaleString("it-IT", {
      day: "numeric", month: "short", hour: "2-digit", minute: "2-digit",
      ...ROME,
    });
  } catch {
    return "";
  }
}

// Convert Italian local wallclock time (date 'YYYY-MM-DD', time 'HH:MM')
// into a UTC ISO string. Handles DST automatically via Intl.
export function italianTimeToUtcIso(date, time) {
  if (!date || !time) return null;
  const [Y, M, D] = date.split("-").map(Number);
  const [h, m] = time.split(":").map(Number);
  if ([Y, M, D, h, m].some((n) => Number.isNaN(n))) return null;
  // Naive: pretend the wallclock is UTC, then discover the actual Rome
  // offset for that moment and compensate.
  const naive = Date.UTC(Y, M - 1, D, h, m, 0);
  const fmt = new Intl.DateTimeFormat("en-US", {
    timeZone: "Europe/Rome",
    hour: "numeric", hour12: false,
    minute: "numeric",
    year: "numeric", month: "numeric", day: "numeric",
  });
  const parts = fmt.formatToParts(new Date(naive)).reduce((acc, p) => {
    acc[p.type] = p.value;
    return acc;
  }, {});
  const romeHour = parseInt(parts.hour, 10);
  // If Rome rendering gives 13 when we wanted 11, offset = 2h ahead.
  // We must subtract that offset from the naive UTC.
  // Watch for date-rollover: compute ms-level diff against the input wallclock.
  const romeWallMs = Date.UTC(parseInt(parts.year), parseInt(parts.month) - 1, parseInt(parts.day), romeHour, parseInt(parts.minute), 0);
  const offsetMs = romeWallMs - naive;
  return new Date(naive - offsetMs).toISOString();
}
